export default __webpack_public_path__ + "static/media/ico-bug-score-moderate.ebc2bd41.svg";